<script>
	import { fade } from "svelte/transition";
	import { cubicOut } from "svelte/easing";

	import LineChart from "./line_chart/LineChart.svelte";

	import { formatFloat, formatFloatAdaptive } from "../utils";
	import { manufacturerProduction } from "../data";
	import { colors } from "../config";

	export let id;
	export let transitionIn = { duration: 2000, easing: cubicOut };
	export let transitionOut = { duration: 2000, easing: cubicOut };

	const sigSauerYTicks = [250000, 500000, 750000, 1000000, 1250000];
	const glockYTicks = [250000, 500000, 750000, 1000000];

	const labels = {
		sig_production: "SIG Sauer",
		glock_production: "Glock",
	};

	const frmt = formatFloatAdaptive({ digits: 1 });
	const frmtLabel = formatFloat({ digits: 0, postfix: " Stück" });

	const yMax = 1294185;
</script>

<div class="produced-weapons" {id} in:fade={transitionIn} out:fade={transitionOut}>
	<div class="container-produced-weapons">
		<div class="container-produced-weapons__item">
			<div class="headline">
				<span>US-PRODUKTION</span>
				<span>SIG SAUER</span>
			</div>
			<LineChart
				data={manufacturerProduction.map((d) => ({ year: d.year, sig_production: d.sig_production }))}
				{yMax}
				yTicks={sigSauerYTicks}
				label={(d) => labels[d.group]}
				formatValueLabel={frmtLabel}
				formatTickY={frmt}
				xGridlines={false}
				yGridlines={true}
				add2021={true}
				paddingLeft={55}
				xTickPosition={"bottom"}
				yTickMarks={false}
				seriesColors={[colors.lineSigsauer]}
				labelPosition="right"
			/>
		</div>
		<div class="container-produced-weapons__item">
			<div class="headline glock">
				<span>US-PRODUKTION</span>
				<span>GLOCK</span>
			</div>
			<LineChart
				data={manufacturerProduction.map((d) => ({ year: d.year, glock_production: d.glock_production }))}
				{yMax}
				yTicks={glockYTicks}
				label={(d) => labels[d.group]}
				formatValueLabel={frmtLabel}
				formatTickY={frmt}
				xGridlines={false}
				yGridlines={true}
				add2021={true}
				cutTop = 50
				paddingLeft={55}
				xTickPosition={"bottom"}
				yTickMarks={false}
				seriesColors={[colors.lineGlock]}
				labelPosition="right"
			/>
		</div>
	</div>
</div>

<style lang="scss">
	.produced-weapons {
		height: 50%;
		width: 80%;
		max-width: 1200px;

		@media (max-width: $breakpoint-mobile) {
			height: 100%;
			width: 80%
		}

		.container-produced-weapons {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			height: 100%;
			max-height: MIN(80vh, 700px);
			display: flex;
			column-gap: 50px;
			row-gap: 50px;
			transform: translateY(-10vh);

			@media (max-width: $breakpoint-mobile) {
				flex-direction: column;
				transform: none;
				margin-top: 20px;
			}

			&__item {
				width: 100%;
				height: 100%;

				&:first-child {
					@media (max-width: $breakpoint-mobile) {
						margin-bottom: 80px;
					}
				}
			}
		}
	}

	.headline {
		@include headline;

		span {
			display: block;
		}

		@media (max-width: $breakpoint-mobile) {
			// margin-bottom: 0;
			min-height: 0;

			span {
				display: inline-block;
			}
		}

		&.glock {
			@media (max-width: $breakpoint-mobile) {
				margin-bottom: -40px;
			}
		}
		
	}

	.chart {
		width: 100%;
		height: 100%;
	}
</style>
